<ngx-spinner [name]="'relatorio-acessos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de acessos</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Período</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate" [min]="minDate"
                        disabled>
                        <input matStartDate formControlName="start" placeholder="Início">
                        <input matEndDate formControlName="end" placeholder="Fim">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
                    </mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Status do usuário</mat-label>
                    <mat-select [(ngModel)]="sbBuscaStatusUsuario">
                        <mat-option *ngFor="let tipo of aTipoStatusUsuario" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Vendedor</mat-label>
                    <mat-select [(ngModel)]="sBuscaVendedor" required
                        [disabled]="tipoCadastro === 'Vendedor' ? true : false">
                        <mat-option *ngFor="let vendedor of aVendedores" [value]="vendedor.value">
                            {{vendedor.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-1">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>UF</mat-label>
                    <mat-select [(ngModel)]="sBuscaUF" (ngModelChange)="carregarCidades()">
                        <mat-option *ngFor="let tipo of aUFs" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Cidade</mat-label>
                    <mat-select [(ngModel)]="sBuscaCidade">
                        <mat-option *ngFor="let tipo of aCidades" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <button class="mt-4" mat-flat-button color="primary" (click)="buscarAcessoUsuarios()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>

        <div class="row mt-4" *ngIf="bConsulta">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="titulo">Total de acessos</div>
                                <div>
                                    <div class="preContador">Total:</div> {{contTotalAcessos}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row mt-4">
                    <div class="col-sm">
                        <div style="color: gray; font-size: small;">* É possível que o último acesso de um usuário
                            desativado
                            apareça na consulta se o filtro for "Todos"</div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>